export const MAX_Z_INDEX = 1000; // the value at which the z-index of the panels are recalculated
export const MAX_PANEL_SIZE = 1; // the percentage of width/height of the workspace the panel should consume when maximized
export const DOUBLE_CLICK_MAX_DELAY = 300; // Maximum number of milliseconds between click events to trigger doubleclick

export const PANEL_TITLE_HEIGHT = 36;
export const PANEL_FRAMELIST_SELECTOR_HEIGHT = 42;
export const PANEL_FRAME_SELECTOR_HEIGHT = 44;
export const PANEL_PLAYBAR_HEIGHT = 30;
export const PLAYBACK_SPEED_CONTROL_HEIGHT = 40;

export const calculateExtraHeight = (
  listOfFrameLists,
  listOfFrames,
  playbackPanelOpened
) => {
  return (
    PANEL_TITLE_HEIGHT +
    (listOfFrameLists && listOfFrameLists.length > 1
      ? PANEL_FRAMELIST_SELECTOR_HEIGHT
      : 0) +
    (listOfFrames && listOfFrames.length > 0
      ? PANEL_FRAME_SELECTOR_HEIGHT
      : 0) +
    PANEL_PLAYBAR_HEIGHT +
    (playbackPanelOpened ? PLAYBACK_SPEED_CONTROL_HEIGHT : 0)
  );
};
